var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"modal__action"},[_c('div',{staticClass:"action",class:_vm.statusActions.class,attrs:{"data-cy":_vm.statusActions.name === 'Desativar'
     ? 'desactivate-captation-unit-btn'
     : 'reactivate-captation-unit-btn'},on:{"click":function($event){return _vm.send()}}},[_c('div',{staticClass:"indicator"}),_c('span',[_vm._v(" "+_vm._s(_vm.statusActions.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }